export const T = {
  tr: {
    welcome: "Z Beach'e Hoş Geldiniz",
    slogan: "Güneş • Kum • Lezzet",
    quickActions: {
      instagram: "Instagram",
      location: "Konum",
      callWaiter: "Garson Çağır",
      wifi: "Wi-Fi",
      playlist: "Playlist",
      contact: "İletişim",
    },
    searchPlaceholder: "Menüde ara... (latte, burger, mojito)",
    all: "Tümü",
    unavailable: "Şu an mevcut değil",
    popular: "Popüler",
    new: "Yeni",
    chef: "Şefin Tavsiyesi",
    vegan: "Vegan",
    vegetarian: "Vejetaryen",
    spicy: "Acılı",
    glutenFree: "Glutensiz",
    details: "Detaylar",
    ingredients: "İçindekiler",
    allergens: "Alerjen Bilgisi",
    portion: "Porsiyon",
    prepTime: "Hazırlanma",
    addToCall: "Garsona Sor",
    close: "Kapat",
    callTitle: "Garson Çağır",
    callPlaceholder: "Not ekle (opsiyonel)",
    callSubmit: "Garson Çağır",
    callSuccess: "Garson çağrınız iletildi. Birazdan yanınızda olacak.",
    wifiTitle: "Wi-Fi Bağlantısı",
    wifiName: "Ağ Adı",
    wifiPassword: "Şifre",
    copy: "Kopyala",
    copied: "Kopyalandı!",
    table: "Masa",
    lounger: "Şezlong",
    cabana: "Cabana",
    vip: "VIP",
    general: "Genel",
    bar: "Bar",
    footer: "Tara • Sipariş Ver • Keyfini Çıkar",
    thanks: "Teşekkürler!",
    noResults: "Sonuç bulunamadı",
  },
  en: {
    welcome: "Welcome to Z Beach",
    slogan: "Sun • Sand • Taste",
    quickActions: {
      instagram: "Instagram",
      location: "Location",
      callWaiter: "Call Waiter",
      wifi: "Wi-Fi",
      playlist: "Playlist",
      contact: "Contact",
    },
    searchPlaceholder: "Search the menu... (latte, burger, mojito)",
    all: "All",
    unavailable: "Currently unavailable",
    popular: "Popular",
    new: "New",
    chef: "Chef's Choice",
    vegan: "Vegan",
    vegetarian: "Vegetarian",
    spicy: "Spicy",
    glutenFree: "Gluten Free",
    details: "Details",
    ingredients: "Ingredients",
    allergens: "Allergens",
    portion: "Portion",
    prepTime: "Prep Time",
    addToCall: "Ask the Waiter",
    close: "Close",
    callTitle: "Call Waiter",
    callPlaceholder: "Add note (optional)",
    callSubmit: "Call Waiter",
    callSuccess: "Your waiter has been notified. They'll be with you shortly.",
    wifiTitle: "Wi-Fi Connection",
    wifiName: "Network Name",
    wifiPassword: "Password",
    copy: "Copy",
    copied: "Copied!",
    table: "Table",
    lounger: "Lounger",
    cabana: "Cabana",
    vip: "VIP",
    general: "General",
    bar: "Bar",
    footer: "Scan • Order • Enjoy",
    thanks: "Thank you!",
    noResults: "No results found",
  },
};

export const useT = (lang) => T[lang] || T.tr;

export const pickLang = (obj, lang, fallbackKey) => {
  const key = lang === "en" ? `${fallbackKey}EN` : `${fallbackKey}TR`;
  return obj?.[key] || obj?.[`${fallbackKey}TR`] || "";
};
